import { render } from "./cp_area.vue?vue&type=template&id=6e213fcb"
import script from "./cp_area.vue?vue&type=script&lang=js"
export * from "./cp_area.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__